import { DiaryDataTypeEnum } from '../../enum/diary-data-type.enum';
import { MediaTranscriptionData } from './media-transcription-data';
import { MediaData } from './media-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class DiaryData {
  DiaryType: DiaryDataTypeEnum;
  DiaryId: string;
  When: string;
  OwnerId: string;
  OwnerName: string;
  Notes: string;
  Transcriptions: MediaTranscriptionData[];
  Audios: MediaData[];
  Images: MediaData[];
  Videos: MediaData[];
  PDFs: MediaData[];
  DiaryCategoryId: string;
  PercentageStanding: number;
  StandingTonnage: number;
  ScaffoldName: string;
  ScaffoldNumber: string;
  SiteAreaName: string;
}


